import { render, staticRenderFns } from "./ContentSection.vue?vue&type=template&id=33edd4fb&scoped=true"
import script from "./ContentSection.js?vue&type=script&lang=js&external"
export * from "./ContentSection.js?vue&type=script&lang=js&external"
import style0 from "./ContentSection.scss?vue&type=style&index=0&id=33edd4fb&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33edd4fb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default,HotImage: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Image/Image.vue').default})
